import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('caravan', {
  cherry: 'date_palm',
  lemon: 'water_jug',
  orange: 'spice_basket',
  bell: 'oasis',
  star: 'camel_wild',
  seven: 'bedouin_tent',
  gem: 'turquoise_beads',
  scatter: 'caravan_map_scatter',
  money: 'trade_chest',
});

/** Desert Caravan — GENERATED by scaffoldSlot from
 *  content/slots/caravan.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const CARAVAN_THEME: Theme = {
  id: 'caravan',
  name: 'Desert Caravan',
  palette: {
    accent: 0xd9a441,
    secondary: 0xc9762e,
    warm: 0xffd98a,
    frameFill: 0x2a1d10,
    bgGradientTop: 0x3a2a14,
    bgGradientBottom: 0x140d05,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Date Palm', glyph: '🌴', tint: 0x6BA84F, weight: 5, textureAlias: 'caravan:cherry',
        winVideoAlias: 'caravan:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Water Jug', glyph: '🏺', tint: 0xC2945A, weight: 5, textureAlias: 'caravan:lemon',
        winVideoAlias: 'caravan:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Spice Basket', glyph: '🧺', tint: 0xD9882E, weight: 4, textureAlias: 'caravan:orange',
        winVideoAlias: 'caravan:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Oasis', glyph: '🏝️', tint: 0x3FB0C8, weight: 3, textureAlias: 'caravan:bell',
        winVideoAlias: 'caravan:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Camel', glyph: '🐫', tint: 0xE8C97A, weight: 2, textureAlias: 'caravan:star',
        winVideoAlias: 'caravan:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Tent', glyph: '⛺', tint: 0xC9762E, weight: 2, textureAlias: 'caravan:seven',
        winVideoAlias: 'caravan:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Trade Beads', glyph: '📿', tint: 0x3FB8B0, weight: 2.5, textureAlias: 'caravan:gem',
        winVideoAlias: 'caravan:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Trade Map', glyph: '🗺️', tint: 0xD9A441, weight: 0.5, textureAlias: 'caravan:scatter',
        winVideoAlias: 'caravan:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Trade Chest', glyph: '🪙', tint: 0xD9A441, weight: 1, textureAlias: 'caravan:money',
        winVideoAlias: 'caravan:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a1d10, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xd9a441, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xc9762e, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xd9a441, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a1d10, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xc9762e, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xd9a441, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffd98a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'caravan:bg', path: 'environment/caravan.png' },
      columnBackground: { alias: 'caravan:column_bg', path: 'reel/caravan_column_bg.png' },
      border: { alias: 'caravan:border', path: 'brand/border_egypt.png' },
    },
  },
};
